import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PrimaryButton } from "../components/Button";
import Navbar from "../components/Navbar";
import PageTitle from "../components/PageTitle";

const SelectPax: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;

    const bookingData = state || {};
    const maxPax = bookingData.trainer?.fullTrainerData?.maxPax || 40;

    const [paxCount, setPaxCount] = useState<number>(1);
    const [error, setError] = useState<string | null>(null);

    const handleContinue = () => {
        if (paxCount < 1 || paxCount > maxPax) {
            setError(`Please enter a number between 1 and ${maxPax}`);
            return;
        }

        navigate('/student/select-address', {
            state: {
                ...bookingData,
                numberOfPax: paxCount
            }
        });
    };

    return (
        <div className="h-[100dvh] w-full bg-[#F7F7F7] overflow-y-auto" style={{ WebkitOverflowScrolling: "touch" }}>
            <div className="w-full min-h-full flex flex-col">
                <Navbar onBack={() => navigate(-1)} background="transparent" spacerHeight={40} />
                <main className="flex-1 px-5">
                    <div className="pt-4">
                        <PageTitle>Select number of pax</PageTitle>

                        {error && (
                            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
                                {error}
                            </div>
                        )}

                        <div className="mt-8 space-y-4">
                            <label className="text-[14px] font-semibold text-black">Number of Persons (1 - {maxPax})</label>
                            <input
                                type="number"
                                min="1"
                                max={maxPax}
                                value={paxCount}
                                onChange={(e) => {
                                    setError(null);
                                    let val = parseInt(e.target.value);
                                    if (isNaN(val)) val = 1;
                                    setPaxCount(val);
                                }}
                                className="w-full border-b border-[#DEDEDE] bg-transparent py-2 text-[18px] outline-none"
                                placeholder="1"
                            />
                        </div>
                    </div>
                </main>
                <div className="px-5 pb-[max(16px,env(safe-area-inset-bottom))] pt-4 bg-[#F7F7F7] border-t border-[#E1E1E1]">
                    <PrimaryButton
                        label="CONTINUE"
                        onClick={handleContinue}
                        disabled={paxCount < 1 || paxCount > maxPax}
                        className="!w-full"
                    />
                </div>
            </div>
        </div>
    );
};

export default SelectPax;
